import { render, staticRenderFns } from "./CampaignWhitelabel.vue?vue&type=template&id=54e28c53"
import script from "./CampaignWhitelabel.vue?vue&type=script&lang=js"
export * from "./CampaignWhitelabel.vue?vue&type=script&lang=js"
import style0 from "./CampaignWhitelabel.vue?vue&type=style&index=0&id=54e28c53&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports